export const SEAT_ORDER = ['top', 'left', 'right', 'hero']

export const ZONES = {
  hand: 'HAND',
  calls: 'CALLS',
  discards: 'POND',
  dora: 'DORA INDICATOR',
}

function items(arr) {
  return (arr || []).map((x) =>
    typeof x === 'string'
      ? { code: x }
      : { code: x.code, highlight: !!x.highlight, rotated: !!x.rotated }
  )
}

export function loadFrame(f) {
  const hero = {
    name: 'You',
    wind: '南',
    score: f.hero.score,
    riichi: f.hero.riichi,
    revealed: true,
    hand: items(f.hero.hand),
    calls: [],
    discards: items(f.hero.discards),
  }
  ;(f.hero.hl || []).forEach((c) => {
    const m = hero.hand.find((x) => x.code === c && !x.highlight)
    if (m) m.highlight = true
  })
  if (f.hero.draw) hero.hand.push({ code: f.hero.draw, highlight: !!f.hero.drawHl })

  const seats = { hero }
  ;['left', 'top', 'right'].forEach((k) => {
    const p = f[k]
    seats[k] = {
      name: p.name,
      wind: p.wind,
      score: p.score,
      riichi: !!p.riichi,
      revealed: false,
      hand: [],
      calls: [],
      discards: items(p.discards),
    }
  })

  return {
    round: f.round,
    wall: f.wall,
    honba: f.honba,
    sticks: f.sticks,
    doraInd: f.doraInd,
    title: f.title,
    body: f.body,
    seats,
    ukeire: f.ukeire ?? null,
    win: !!f.win,
    turn: f.turn ?? null,
  }
}

export function blankFrame(current) {
  return loadFrame({
    round: current.round,
    wall: current.wall,
    honba: 0,
    sticks: 0,
    doraInd: current.doraInd,
    title: '',
    body: '',
    ukeire: null,
    win: false,
    turn: current.turn ?? null,
    hero: { score: 25000, riichi: false, hand: [], discards: [] },
    left: {
      name: current.seats.left.name,
      wind: current.seats.left.wind,
      score: 25000,
      discards: [],
    },
    top: {
      name: current.seats.top.name,
      wind: current.seats.top.wind,
      score: 25000,
      discards: [],
    },
    right: {
      name: current.seats.right.name,
      wind: current.seats.right.wind,
      score: 25000,
      discards: [],
    },
  })
}

export function serializeHand(hand) {
  const g = {}
  hand.forEach((x) => {
    if (x.code === 'xx') g.x = (g.x || '') + 'x'
    else g[x.code[1]] = (g[x.code[1]] || '') + x.code[0]
  })
  return ['m', 'p', 's', 'z'].map((s) => (g[s] ? g[s] + s : '')).join('') + (g.x || '')
}

export function parseNotation(str) {
  const out = []
  const re = /([0-9]+)([mpsz])|(x)/g
  let m
  while ((m = re.exec(str))) {
    if (m[3]) out.push({ code: 'xx' })
    else m[1].split('').forEach((d) => out.push({ code: d + m[2] }))
  }
  return out.slice(0, 14)
}
